import { NgModule } from '@angular/core'
import { Routes, RouterModule } from '@angular/router'
import { AdminDashboardComponent } from './views/admin-dashboard/admin-dashboard.component'
import { LoginPageComponent } from './views/login-page/login-page.component'
import { AboutPageComponent } from './views/about-page/about-page.component'
import { ContactPageComponent } from './views/contact-page/contact-page.component'
import { RegisterPageComponent } from './views/register-page/register-page.component'
import { RegisterFinancialInstitutionComponent } from './views/register-financial-institution/register-financial-institution.component'
import { RegisterMasterAgentComponent } from './views/register-master-agent/register-master-agent.component'
import { AuthGuard } from './_guards/auth.guard'
import { AdminGuard } from './_guards/admin.guard'

import { CountryGuardGuard } from './_guards/country-guard.guard'
import { ReportPageComponent } from './views/report-page/report-page.component'
import { ForgotPasswordPageComponent } from './views/forgot-password-page/forgot-password-page.component'
import { ConfirmPasswordPageComponent } from './views/confirm-password-page/confirm-password-page.component'
import { MasteragentComponent } from './views/masteragent/masteragent.component'
import { AdminRegisterMasteragentComponent } from './views/admin-register-masteragent/admin-register-masteragent.component'
import { DevtpartnerComponent } from './views/devtpartner/devtpartner.component'
import { AdminRegisterDevtpartnerComponent } from './views/admin-register-devtpartner/admin-register-devtpartner.component'
import { AdminListComponent } from './views/admin-list/admin-list.component'
import { NewAdminComponent } from './views/new-admin/new-admin.component'
import { ChangePasswordFormComponent } from './views/change-password/change-password.component'

import { EditAdminComponent } from './views/edit-admin/edit-admin.component'
import { EditModalComponent } from './components/edit-modal/edit-modal.component'
import { AdminUsersLogComponent } from './views/admin-users-log/admin-users-log.component'
import { GovernmentComponent } from './views/government/government.component'
import { AdminRegisterGovernmentComponent } from './views/admin-register-government/admin-register-government.component'
import { AppManagementDashboardComponent } from './views/_app-management/app-management-dashboard/app-management-dashboard.component'

import { DiseasesComponent } from './views/_app-management/diseases/diseases.component'
import { PestsComponent } from './views/_app-management/pests/pests.component'
import { AgronomicalComponent } from './views/_app-management/agronomical/agronomical.component'
import { VillageagentsComponent } from './views/villageagents/villageagents.component'
import { FinancialinstitutionComponent } from './views/financialinstitution/financialinstitution.component'
import { FarmersComponent } from './views/farmers/farmers.component'
import { PageNotFoundComponent } from './views/page-not-found/page-not-found.component'
import { MarketInfoComponent } from './views/_app-management/market-info/market-info.component'
import { SendNotificationsComponent } from './views/_app-management/send-notifications/send-notifications.component'
import { SmartDiagnosisDiseaseComponent } from './views/_app-management/smart-diagnosis-disease/smart-diagnosis-disease.component'
import { SmartDiagnosisPestComponent } from './views/_app-management/smart-diagnosis-pest/smart-diagnosis-pest.component'
import { CropinfoHeadingsComponent } from './views/_app-management/cropinfo-headings/cropinfo-headings.component'

import { CropDetailComponent } from './views/_app-management/crop-detail/crop-detail.component'
import { AllCropDataComponent } from './views/_app-management/all-crop-data/all-crop-data.component'
import { IndiaManagementDashboardComponent } from './views/_app-management/india-management-dashboard/india-management-dashboard.component'
import { NewMarketInfoDesignComponent } from './views/_app-management/new-market-info-design/new-market-info-design.component'
import { ContactsComponent } from './views/_app-management/contacts/contacts.component'
import { FinancialLitTopicsComponent } from './views/_app-management/financial-lit-topics/financial-lit-topics.component'
import { FinancialLiteracyComponent } from './views/_app-management/financial-literacy/financial-literacy.component'
import { VideosComponent } from './views/_app-management/videos/videos.component'
import { AnimalComponent } from './views/_app-management/animal/animal.component'
import { AnimalDetailComponent } from './views/_app-management/animal-detail/animal-detail.component'
import { ReferralsComponent } from './views/usage/referrals-list/referrals.component'
import { ReferralDetailsComponent } from './views/usage/referral-details/referral-details.component'
import { ReferralShellComponent } from './views/usage/referral-shell/referral-shell.component'
import { AppUsageComponent } from './views/usage/app-usage/app-usage.component'
import { EzyagricUsersComponent } from './views/usage/ezyagric-users/ezyagric-users.component'
import { PurchaseOrderReceiptComponent } from './components/purchase-order-receipt/purchase-order-receipt.component'
import { PrintLayoutComponent } from './components/print-layout/print-layout.component'
import { OrderInvoiceComponent } from './views/agrishop/orders/order-invoice/order-invoice.component'
import { OrderStatsComponent } from './views/agrishop/orders/orderstats/orderstats.component'
import { PushNotificationsComponent } from './views/push-notifications/push-notifications.component'
import { PermissionGuard } from './_guards/permission.guard'

const routes: Routes = [
  {
    path: '',
    component: LoginPageComponent,
  },
  {
    path: 'agrishop',
    loadChildren: () =>
      import('./views/agrishop/agrishop.module').then((m) => m.AgrishopModule),
  },
  {
    path: 'usage',
    redirectTo: 'usage/shop',
    pathMatch: 'full',
  },
  {
    path: 'usage',
    canActivate: [AuthGuard],
    children: [
      {
        path: 'shop',
        component: AppUsageComponent,
        data: {
          label: 'Agrishop',
          tag: 'agrishop',
        },
      },
      {
        path: 'farmmanager',
        component: AppUsageComponent,
        data: {
          label: 'Farm manager',
          tag: 'farm_manager',
        },
      },
      {
        path: 'betterextension',
        component: AppUsageComponent,
        data: {
          label: 'Better Extension',
          tag: 'better_extension',
        },
      },
      {
        path: 'ezycredits',
        component: AppUsageComponent,
        data: {
          label: 'Ezy Credits',
          tag: 'ezycredits',
        },
      },
      {
        path: 'producemarket',
        component: AppUsageComponent,
        data: {
          label: 'Produce market',
          tag: 'produce_market',
        },
      },
      {
        path: 'referrals',
        component: ReferralShellComponent,
        canActivate: [AuthGuard],
        data: {
          label: 'Usage',
        },
        children: [
          {
            path: '',
            component: ReferralsComponent,
            data: {
              label: 'Referrals',
            },
          },
          {
            path: ':id',
            component: ReferralDetailsComponent,
          },
        ],
      },
    ],
  },
  {
    path: 'ezyusers',
    component: EzyagricUsersComponent,
    canActivate: [AuthGuard],
    data: {
      label: 'Usage',
    },
  },
  {
    path: 'india-dashboard',
    component: IndiaManagementDashboardComponent,
    canActivate: [AuthGuard],
    data: {
      title: 'India Admin Dashboard',
    },
  },
  {
    path: 'contacts',
    component: ContactsComponent,
    canActivate: [AuthGuard],
    data: {
      title: 'Contacts',
    },
  },
  {
    path: 'financial-lit-topics',
    component: FinancialLitTopicsComponent,
    canActivate: [AuthGuard],
  },
  {
    path: 'financial',
    component: FinancialLiteracyComponent,
    canActivate: [AuthGuard],
  },
  {
    path: 'videos',
    component: VideosComponent,
    canActivate: [AuthGuard],
  },
  {
    path: 'animal',
    component: AnimalComponent,
    canActivate: [AuthGuard],
  },
  {
    path: 'animal-details',
    component: AnimalDetailComponent,
    canActivate: [AuthGuard],
  },
  {
    path: 'admin_dashboard',
    component: AdminDashboardComponent,
    canActivate: [AuthGuard],
    data: {
      title: 'Akorion Admin Dashboard',
    },
  },
  {
    path: 'change-password',
    component: ChangePasswordFormComponent,
    canActivate: [AuthGuard],
    data: {
      title: 'Change Password',
    },
  },
  {
    path: 'admin-user-logs',
    component: AdminUsersLogComponent,
    canActivate: [AuthGuard],
    data: {
      title: 'User logs',
    },
  },
  {
    path: 'about',
    component: AboutPageComponent,
    data: {
      title: 'About us',
    },
  },
  {
    path: 'contact',
    component: ContactPageComponent,
  },
  { path: 'confirm-password', component: ConfirmPasswordPageComponent },
  { path: 'forgot-password', component: ForgotPasswordPageComponent },
  { path: 'register', component: RegisterPageComponent },
  {
    path: 'register/financial-institution',
    component: RegisterFinancialInstitutionComponent,
  },
  {
    path: 'register/master-agent',
    component: RegisterMasterAgentComponent,
  },
  {
    path: 'admin/report',
    canActivate: [AuthGuard],
    component: ReportPageComponent,
  },
  {
    path: 'masteragents',
    component: MasteragentComponent,
    canActivate: [AuthGuard],
  },
  {
    path: 'create/masteragent',
    component: AdminRegisterMasteragentComponent,
    canActivate: [AuthGuard],
  },
  {
    path: 'devt-partners',
    component: DevtpartnerComponent,
    canActivate: [AuthGuard],
  },
  {
    path: 'create/devt-partners',
    component: AdminRegisterDevtpartnerComponent,
    canActivate: [AuthGuard],
  },
  {
    path: 'admins',
    component: AdminListComponent,
    canActivate: [AuthGuard],
  },
  {
    path: 'create/admin',
    component: NewAdminComponent,
    canActivate: [AuthGuard],
  },
  {
    path: 'admin/account/:id',
    component: EditAdminComponent,
    canActivate: [AuthGuard],
  },
  {
    path: 'account/:id',
    component: EditModalComponent,
    canActivate: [AuthGuard],
  },
  {
    path: 'government',
    component: GovernmentComponent,
    canActivate: [AuthGuard],
  },
  {
    path: 'create/government',
    component: AdminRegisterGovernmentComponent,
    canActivate: [AuthGuard],
  },
  {
    path: 'mobile-dashboard',
    component: AppManagementDashboardComponent,
    canActivate: [AuthGuard, CountryGuardGuard],
  },
  {
    path: 'mobile-diseases',
    component: DiseasesComponent,
    canActivate: [AuthGuard],
  },
  {
    path: 'mobile-pests',
    component: PestsComponent,
    canActivate: [AuthGuard],
  },
  {
    path: 'mobile-smart-diseases',
    component: SmartDiagnosisDiseaseComponent,
    canActivate: [AuthGuard],
  },
  {
    path: 'mobile-pest-diseases',
    component: SmartDiagnosisPestComponent,
    canActivate: [AuthGuard],
  },
  {
    path: 'mobile-agronomical',
    component: AgronomicalComponent,
    canActivate: [AuthGuard],
  },
  {
    path: 'crop',
    component: AllCropDataComponent,
    canActivate: [AuthGuard],
  },
  {
    path: 'crop-details',
    component: CropDetailComponent,
    canActivate: [AuthGuard],
  },
  {
    path: 'mobile-agronomical-heading',
    component: CropinfoHeadingsComponent,
    canActivate: [AuthGuard],
  },
  {
    path: 'mobile-market-info',
    component: MarketInfoComponent,
    canActivate: [AuthGuard, CountryGuardGuard],
  },
  {
    path: 'mobile-new-market-info',
    component: NewMarketInfoDesignComponent,
    canActivate: [AuthGuard, CountryGuardGuard],
  },
  {
    path: 'farmers',
    component: FarmersComponent,
    canActivate: [AuthGuard],
  },
  {
    path: 'financial-institutions',
    component: FinancialinstitutionComponent,
    canActivate: [AuthGuard],
  },
  {
    path: 'village-agents',
    component: VillageagentsComponent,
    canActivate: [AuthGuard],
  },
  {
    path: 'send-notifications',
    component: SendNotificationsComponent,
    canActivate: [AuthGuard, CountryGuardGuard],
  },
  {
    path: 'push-notifications',
    component: PushNotificationsComponent,
    canActivate: [AuthGuard, CountryGuardGuard],
  },
  {
    path: 'services',
    loadChildren: () =>
      import('./services/services-routing.module').then(
        (m) => m.ServicesRoutingModule
      ),
    canActivate: [AuthGuard, PermissionGuard],
    canActivateChild: [AuthGuard, PermissionGuard],
    data: {
      title: 'Services',
      permissions: ["services.view"],
    }
  },
  {
    path: 'print',
    outlet: 'print',
    component: PrintLayoutComponent,
    children: [
      { path: 'agrishop', component: PurchaseOrderReceiptComponent },
      { path: 'order', component: OrderInvoiceComponent },
      { path: 'stats', component: OrderStatsComponent, data: { print: true } },
    ],
  },
  {
    path: 'users',
    loadChildren: () =>
      import('./views/user-management/user-management.module').then(
        (m) => m.UserManagementModule
      ),
    canActivate: [AuthGuard, AdminGuard],
  },
  {
    path: '**',
    component: PageNotFoundComponent,
    canActivate: [AuthGuard],
  },
]
@NgModule({
  imports: [RouterModule.forRoot(routes, {
    paramsInheritanceStrategy: 'always'
  })],
  exports: [RouterModule],
})
export class AppRoutingModule { }
